<template>
  <div class="view-contanier">
    <div class="opt">
      <div class="btn" @click="add">
        <svg-icon className="icon" iconClass="add" />新增
      </div>
      <div class="btn" @click="exportFile">
        <img src="@/assets/images/bill/import.png" alt="" />导出
      </div>
      <BaseFilter
        :isActive="isActive"
        :width="516"
        @sendFilter="sendFilter"
        @reset="reset"
      >
        <div class="filter">
          <el-form ref="form" :model="filterList" label-width="116px">
            <el-form-item label="供应商代码/名称">
              <el-input
                v-model="filterList.search"
                placeholder="请输入供应商代码/名称/简称"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="业务范畴">
              <div class="select">
                <el-select
                  v-model="filterList.scopeValue"
                  placeholder="请选择业务范畴"
                  style="width: 320px"
                >
                  <el-option
                    v-for="item in supplierScopeOptions"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="状态">
              <div class="select">
                <el-select
                  v-model="filterList.isActived"
                  placeholder="请选择状态"
                  style="width: 320px"
                >
                  <el-option
                    v-for="item in activeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </BaseFilter>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :loading="loading"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="isActived" slot-scope="row">
          <div
            class="circle"
            :style="{
              'background-color': row.scope.isActived ? ' #35BA83' : '#FE453D',
            }"
          ></div>
          {{ row.scope.isActived ? "使用中" : "未使用" }}
        </template>
        <template slot="supplierScope" slot-scope="row">
          <el-tag
            v-for="(item, $index) in row.scope.scopeTypes"
            :key="$index"
          >
            {{ formatterTypes(item) }}
          </el-tag>
        </template>
        <template slot="clearanceModes" slot-scope="row">
          <el-tag
            v-for="(item, $index) in row.scope.clearanceModes"
            :key="$index"
          >
            {{ formatterClearanceModes(item) }}
          </el-tag>
        </template>
        <template slot="address" slot-scope="row">
          <el-tooltip
            class="item"
            effect="dark"
            :tabindex="2000"
            placement="bottom"
          >
            <div slot="content">
              {{
                `${row.scope.countryId}/${row.scope.provinceId}/${row.scope.cityId}`
                  | formatterAddress
              }}{{ row.scope.address }}
            </div>
            <svg-icon iconClass="address" className="icon" />
          </el-tooltip>
        </template>
        <template slot="remark" slot-scope="row">
          <el-tooltip
            class="item"
            effect="dark"
            :tabindex="2000"
            :content="row.scope.remark"
            placement="bottom"
          >
            <svg-icon iconClass="remark" className="icon" />
          </el-tooltip>
        </template>
        <template slot="payableAmount" slot-scope="row">
          {{ row.scope.supplierAmount?.payableAmount + ' ' + row.scope.supplierAmount?.currency }}
        </template>
        <template slot="drafryAmount" slot-scope="row">
          {{ row.scope.supplierAmount?.drafryAmount + ' ' + row.scope.supplierAmount?.currency }}
        </template>
        <template slot="currentAmount" slot-scope="row">
          {{ row.scope.supplierAmount?.currentAmount + ' ' + row.scope.supplierAmount?.currency }}
        </template>
        <template slot="verifedAmount" slot-scope="row">
          {{ row.scope.supplierAmount?.verifedAmount + ' ' + row.scope.supplierAmount?.currency }}
        </template>
        <template slot="unpaidAmount" slot-scope="row">
          {{ row.scope.supplierAmount?.unpaidAmount + ' ' + row.scope.supplierAmount?.currency }}
        </template>
        <!-- <template slot="drafryAmount" slot-scope="row">
          <template v-if="row.scope.supplierAmount.length > 0">
            <div v-for="(item, $index) in row.scope.supplierAmount" :key="$index" style="text-align: right;">
              {{ item.drafryAmount + ' ' + item.currency }}
            </div>
          </template>
        </template> -->
        <template slot="fileList" slot-scope="row">
          <el-popover
            placement="bottom"
            width="608"
            trigger="hover">
            <BaseTable
              :height="320"
              :isPager="false"
              :tableData="{
                ...tableData1,
                columns: row.scope.fileList
              }">
              <template slot="code" slot-scope="row1">
                {{ row1.scope.fileName.split('.')[1].toUpperCase() }}
              </template>
              <template slot="opt" slot-scope="row1">
                <div style="fontSize: 20px; color: rgb(18,88,188)">
                  <span title="下载" @click="download(row1.scope)">
                    <svg-icon iconClass="download" className="icon" />
                  </span>
                  <i style="margin-left: 20px" title="预览" class="el-icon-zoom-in" @click="review(row1.scope)" />
                </div>
              </template>
            </BaseTable>
            <span slot="reference" style="color:  rgb(18,88,188);">
              <i class="el-icon-paperclip" />
              查看
            </span>
          </el-popover>

        </template>
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  class="opt-item"
                  @click="() => {
                    changeStatus(row.scope);
                  }"
                >{{ !row.scope.isActived ? "启用" : "停用" }}</el-button
                >
                <el-button
                  v-permissson="'update'"
                  class="opt-item"
                  @click="updateRow(row.scope)"
                >修改</el-button
                >
                <!-- <el-button
                  v-permissson="'priceSetting'"
                  class="opt-item"
                  @click="priceSet(row.scope)"
                >价格设置</el-button
                > -->
              </div>
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
      </BaseTable>
    </div>
    <AddSupplyDrawer
      :drawer="drawer"
      :editData="editData"
      @ok="ok"
      @close="cancel"></AddSupplyDrawer>
    <PriceSetDrawer :drawer="drawer1" :rowData="editData" :tplType="1" @close="drawer1 = false" />
  </div>
</template>

<script>
let that
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const PriceSetDrawer = () => import('@/components/drawer/PriceSetDrawer')
import {
  getSupplierPageList,
  switchSupplier,
  getSysParams
} from '@/api/system'
import {
  downLoadFile
} from '@/api/setting'
import { mapGetters } from 'vuex'
import { derive } from '@/utils/common'
import AddSupplyDrawer from './components/AddSupplyDrawer.vue'
import { myMixins } from '@/mixins'
import dayjs from 'dayjs'
import config from '@/utils/config'
export default {
  name: 'Supply',
  components: { BaseTable, BaseFilter, AddSupplyDrawer, PriceSetDrawer },
  filters: {
    formatterAddress(val) {
      const arr = val.split('/')
      const country =
        that.addressDropOption &&
        that.addressDropOption.find((a) => a.value === parseInt(arr[0], 10))
      const province =
        country &&
        country.children.find((a) => a.value === parseInt(arr[1], 10))
      const city =
        province &&
        province.children.find((a) => a.value === parseInt(arr[2], 10))
      let addressStr = ''
      if (country && province && city) {
        addressStr = `${country.label}${province.label}${city.label}`
      }
      return addressStr
    }
  },
  mixins: [myMixins],
  data() {
    return {
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      loading: false,
      tableData: {
        fileds: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'code',
            label: '代码',
            width: '100px',
            fixed: 'left',
            align: 'left'
          },
          {
            filed: 'wbName',
            label: '简称',
            width: '120px',
            align: 'left'
          },
          {
            filed: 'name',
            label: '供应商名称',
            width: '120px',
            align: 'left'
          },
          // {
          //   filed: 'nameEN',
          //   label: '英文全称',
          //   width: '140px'
          // },
          {
            filed: 'supplierScope',
            label: '业务范畴',
            width: '250px',
            isCustom: true
          },
          {
            filed: 'clearanceModes',
            label: '清关模式',
            width: '250px',
            isCustom: true
          },
          {
            filed: 'isActived',
            label: '状态',
            width: '140',
            isCustom: true,
            isSort: true
          },
          {
            filed: 'phone',
            label: '联系电话',
            width: '116',
            align: 'left'
          },
          {
            filed: 'email',
            label: '邮箱',
            width: '170',
            align: 'left'
          },
          {
            filed: 'address',
            label: '地址',
            width: '60px',
            isCustom: true
          },
          {
            filed: 'remark',
            label: '备注',
            width: '60px',
            isCustom: true
          },
          {
            filed: 'payableAmount',
            label: '应付总金额',
            width: '160px',
            isCustom: true
          },
          // {
          //   filed: 'drafryAmount',
          //   label: '已申付总额',
          //   width: '160px',
          //   isCustom: true
          // },
          {
            filed: 'currentAmount',
            label: '未付总金额',
            width: '160px',
            isCustom: true
          },
          {
            filed: 'verifedAmount',
            label: '已核销金额',
            width: '160px',
            isCustom: true
          },
          {
            filed: 'unpaidAmount',
            label: '剩余未付金额',
            width: '160px',
            isCustom: true,
            tip: true,
            tipContent: '应付总金额 - 已核销金额'
          },
          {
            filed: 'lastVerifyDate',
            label: '最后核销日期',
            width: '120',
            formatter: (row) => {
              return row.supplierAmount?.lastVerifyDate
                ? dayjs(row.supplierAmount?.lastVerifyDate).format('YYYY-MM-DD')
                : ''
            }
          },
          {
            filed: 'lastVerifyName',
            label: '最后核销人',
            width: '120',
            formatter: (row) => {
              return row.supplierAmount?.lastVerifyName
            }
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '150',
            formatter: (row) =>
              row.createdOn ? row.createdOn.slice(0, row.createdOn.length - 3) : '',
            align: 'left',
            isSort: true
          },
          {
            filed: 'createdName',
            label: '创建人',
            width: '160px',
            align: 'left'
          },
          {
            filed: 'updatedOn',
            label: '修改时间',
            width: '150',
            formatter: (row) =>
              row.updatedOn ? row.updatedOn.slice(0, row.updatedOn.length - 3) : '',
            align: 'left',
            isSort: true
          },
          {
            filed: 'updatedName',
            label: '修改人',
            width: '160px',
            align: 'left'
          },
          {
            filed: 'fileList',
            label: '附件',
            width: '160px',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      tableData1: {
        fileds: [
          {
            filed: 'fileName',
            label: '文件名',
            width: ''
          },
          {
            filed: 'code',
            label: '文件类型',
            width: '80',
            isCustom: true
          },
          {
            filed: 'opt',
            label: '操作',
            width: '100',
            isCustom: true
          }
        ]
      },
      height: 0,
      drawer: false,
      drawer1: false,
      editData: {},
      filterList: {
        search: '',
        isActived: '',
        scopeValue: []
      },
      activeOption: [
        {
          value: true,
          label: '使用中'
        },
        {
          value: false,
          label: '未使用'
        }
      ],
      isActive: false,
      supplierScopeOptions: [],
      sortable: {},
      clearanceModesOptions: config.clearanceModesOptions
    }
  },
  computed: {
    ...mapGetters(['addressDropOption'])
  },
  beforeCreate: function() {
    that = this
  },
  created() {
    this.getList(this.pagerConfig)
    this.getCommData()
  },
  mounted() {
    if (!this.addressDropOption || this.addressDropOption.length === 0) {
      this.$store.dispatch('getAddress')
    }
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            ...this.formatterFilter()
          }
        }
        getSupplierPageList(params).then((res) => {
          if (res.success) {
            this.loading = false
            this.tableData.total = res.data.total
            this.tableData.columns = res.data.list
          } else {
            this.loading = false
            this.$message.error(res.errorMessage)
          }
        })
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    getCommData() {
      getSysParams({ type: 12 }).then((res) => {
        if (res.success) {
          const arr = []
          res.data &&
            res.data[0].value &&
            res.data[0].value.map((item) => {
              arr.push({
                label: item.description,
                value: item.dbValue,
                id: item.id
              })
            })
          this.supplierScopeOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    formatterTypes(id) {
      if (!id) return ''
      return this.supplierScopeOptions.find(a => +a.id === +id)?.label
    },
    formatterClearanceModes(id) {
      if (!id) return ''
      return this.clearanceModesOptions.find(a => +a.value === +id)?.label
    },
    updateRow(row) {
      this.editData = row
      this.drawer = true
    },
    changeStatus(row) {
      switchSupplier({
        id: row.id
      }).then((res) => {
        res.success && this.$message.success('设置成功')
        this.getList(this.pagerConfig)
      })
    },
    handlePageChange(pager) {
      this.pagerConfig = { ...pager }
      this.getList(pager)
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getList(this.pagerConfig)
    },
    add() {
      this.drawer = true
    },
    ok() {
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
      this.drawer = false
      this.editData = {}
    },
    cancel() {
      this.drawer = false
      this.editData = {}
    },
    log(row) {
      this.editData = row
      this.drawer = true
    },
    close() {
      this.editData = {}
      this.drawer = false
    },
    formatterFilter() {
      return {
        search:
          this.filterList.search !== ''
            ? this.filterList.search
            : undefined,
        isActived:
          this.filterList.isActived !== ''
            ? this.filterList.isActived
            : undefined,
        scopeValue:
          (this.filterList.scopeValue && this.filterList.scopeValue.length > 0)
            ? this.filterList.scopeValue
            : undefined
      }
    },
    sendFilter() {
      if (
        this.filterList.search !== '' ||
        this.filterList.isActived !== '' ||
        (this.filterList.scopeValue && this.filterList.scopeValue.length > 0)
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
    },
    reset() {
      this.filterList = {
        search: '',
        isActived: ''
      }
      this.isActive = false
    },
    exportFile() {
      derive('supplier/exportSupplier', 'post', this.formatterFilter())
    },
   async download(v) {
      try {
        const res = await downLoadFile({ guid: v.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
      // const elink = document.createElement('a')
      // elink.style.display = 'none'
      // elink.href = v.filePath
      // document.body.appendChild(elink)
      // elink.click()
      // URL.revokeObjectURL(elink.href)
      // document.body.removeChild(elink)
    },
    review(item) {
        const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      )
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: item.filePath
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(
          item.filePath
        )
      }
    },
    priceSet(row) {
      this.editData = row
      this.drawer1 = true
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .opt {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .btn {
    width: 80px;
    height: 30px;
    background:  rgb(18,88,188);
    border-radius: 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
    img {
      vertical-align: -4px;
    }
  }
  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  }
  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }
  .table-opt:deep(.el-button) {
    padding: 0;
  }
  .filter {
    width: 438px;
  }
}
.select {
  width: 100%;
  &:deep(.el-select) {
    width: 100%;
  }
}
.table-opt:deep(.el-button) {
  padding: 0;
}
.status {
  width: 28px;
  height: 19px;
  font-size: 14px;
  font-weight: 400;
  color:  rgb(18,88,188);
  line-height: 20px;
  margin-left: 5px;
  margin-right: 31px;
}
.icon {
  font-size: 24px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
